import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import MyOrderGrid from "./MyOrderGrid";
import { Datepicker, Tooltip } from "../../../../CommonComponents";
import { useDispatch, useSelector } from "react-redux";
import customerMyOrderDetails from "../../../../../redux/CustomerMyOrder/operations";
import comment from "../../../../assets/images/Comments.png";
import Moment from "moment";
import pendingApprovalOperations from "../../../../../redux/PendingOrder/operations";
import Edit from "../../../../assets/images/EditIcon.svg";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { useNavigate } from "react-router-dom";
import { GetOnOrderIdClickedUrl } from "../../mainUtil";
import { GetStatusIcon } from "client/utils/IconsUtil";
import { CONSTANTS } from "client/utils/constants";
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import { ACTIVE_NAVIGATION } from "../../../../utils/constants/activeNavigationConstant"
import { getMyOrder } from "redux/CustomerMyOrder/actions";
import { getTransferGridData } from "Store/Transfer/TransferGrid/TransferGridAction";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import userProfileSelectors from '../../../../../redux/UserProfile/selectors'
import { getAssetType, getNonRequisitionAssetType } from "Store/AssetManagement/AssetType/AssetTypeAction";
import { getAssignedToList, getBuyerNameList } from "Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction";
import OrderDispatch from "Store/OrderManagement/Order/OrderDispatch";
import { fetchGridPayload, formatPrice } from "utils";
import { CustomTextFilterDiv, commonFilterDropDown } from "client/utils/RequisitionUtil";

const MyOrderGridContainer = ({ data, activeMenu, assetGridFilters, requestGridFilters,
  dateRange, myOrdersearchBoxValue, serverTotal, costCenterList, fleetItemStatusList, orderRequestList, updatedByList, assignedToList, requestedByList, regionList, orderStatusList, buyerNameList, globalSearchBy}: any) => {
  const orderDate = useRef<any>(null);
  const updateDate = useRef<any>(null);
  const selectStatus = useRef("");
  const selectRegion = useRef("");
  const selectCostCenter = useRef("");
  const selectRequsetType = useRef('');
  const selectRequestedBy = useRef('');
  const selectAssignedTo = useRef('');
  const selectUpdatedBy = useRef('');
  const selectItemStatus = useRef('');
  const selectBuyerName = useRef('');
  const orderPriceFilterRef = useRef<any>('');

  const [orderList, setOrderList] = useState(data || []);
  const [paginationData, setPaginationData] = useState<any>({})
  const [quantityFilter, setQuantityFilter] = useState<any>('')
  const [orderIdFilter, setOrderIdFilter] = useState<any>('')
  const [assetNumberfilter, setAssetNumberFilter] = useState<any>('')
  const [orderPriceFilter, setOrderPriceFilter] = useState<any>('')
  const [frsOrderNumberFilter, setFrsOrderNumberFilter] = useState<any>('')
  const [commentFilter, setCommentFilter] = useState<any>('')
  const [sortData, setSortData] = useState<any>('')
  const [gridKey, setGridKey] = useState<number>(0)
  const lastCommonSearchSignatureRef = useRef<string | null>(null)
  const lastColumnFilterSignatureRef = useRef<string | null>(null)
  const forceFirstPageForCommonSearchRef = useRef<boolean>(false)
  const [pagesCount, setPagesCount] = useState<number>(0)

  const {
    activeNavigation,
    statusDropdownList,
    regionDropdownList,
    costCenterDropdownList,
    requestedByDropdownList,
    assignedToDropdownList,
    updatedByDropdownList,
    requisitionTypeDropdownList,
    assetTypeDropdownList,
    itemStatusDropdownList,
    userDetails,
    buyerNameDropDownList,
    isMyOrdersGridLoading,
    isDropDownsLoading
  }: any = useSelector(
    (state: any) => ({
      activeNavigation: state.nav.nav,
      statusDropdownList: state.OrderGridDropdownsReducer.statusList,
      regionDropdownList: state.OrderGridDropdownsReducer.regionList,
      costCenterDropdownList: state.OrderGridDropdownsReducer.costCenterList,
      requestedByDropdownList: state.OrderGridDropdownsReducer.requestedByList,
      assignedToDropdownList: state.OrderGridDropdownsReducer.assignedToList,
      updatedByDropdownList: state.OrderGridDropdownsReducer.updatedByList,
      requisitionTypeDropdownList: state.AssetManagement.AssetType,
      assetTypeDropdownList: state.AssetManagement.NonRequisitionAssetType,
      itemStatusDropdownList: state?.fleetAdminTaskReducer?.itemStatusList,
      userDetails: userProfileSelectors.getUserDetails(state),
      buyerNameDropDownList: state.OrderGridDropdownsReducer.buyerNameList,
      isMyOrdersGridLoading: state.TransferGridReducer.isMyOrdersGridLoading,
      isDropDownsLoading: state.OrderGridDropdownsReducer.isDropDownsLoading
    })
  );


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dispatchGetCartCount = OrderDispatch.dispatchGetCartCount(dispatch);

  useEffect(() => {
    userDetails?.emailId && dispatchGetCartCount(userDetails?.emailId);
    !(requisitionTypeDropdownList?.length > 0) && dispatch(getAssetType(false));
    !(assetTypeDropdownList?.length > 0) && dispatch(getNonRequisitionAssetType());
    !(buyerNameDropDownList?.length > 0) && dispatch(getBuyerNameList())
    dispatch(getAssignedToList());
  }, []);

 let setValues = () =>{
    orderDate.current = null;
    updateDate.current = null;
    selectStatus.current = "";
    selectRegion.current = "";
    selectCostCenter.current = "";
    selectRequestedBy.current = "";
    selectAssignedTo.current = "";
    selectUpdatedBy.current = "";
    selectRequsetType.current = '';
    selectItemStatus.current = '';
    selectBuyerName.current = '';
    orderPriceFilterRef.current = '';

    //activemenu in effect dependecy removed because call 2 time so
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setFrsOrderNumberFilter(assetGridFilters?.frsOrderNumber)
      setCommentFilter(assetGridFilters?.comment)
      if (assetGridFilters?.status) {
        selectStatus.current = assetGridFilters?.status
      }else{
        selectStatus.current = ""
      }
      if (assetGridFilters?.regionName) {
        selectRegion.current = assetGridFilters?.regionName
      }else{
        selectRegion.current = ""
      }
      if (assetGridFilters?.costCenter) {
        selectCostCenter.current = assetGridFilters?.costCenter
      }else{
        selectCostCenter.current = ""
      }
      if (assetGridFilters?.orderRequestType) {
        selectRequsetType.current = assetGridFilters?.orderRequestType
      }else{
        selectRequsetType.current = ""
      }
      if (assetGridFilters?.requestedBy) {
        selectRequestedBy.current = assetGridFilters?.requestedBy
      }else{
        selectRequestedBy.current = ""
      }
      if (assetGridFilters?.assignedTo) {
        selectAssignedTo.current = assetGridFilters?.assignedTo
      }else{
        selectAssignedTo.current = ""
      }
      if (assetGridFilters?.updatedBy) {
        selectUpdatedBy.current = assetGridFilters?.updatedBy
      }else{
        selectUpdatedBy.current = ""
      }
      if(assetGridFilters?.fleetItemStatus){
        selectItemStatus.current = assetGridFilters?.fleetItemStatus
      }else{
        selectItemStatus.current = ""
      }
      if(assetGridFilters?.buyerName){
        selectBuyerName.current = assetGridFilters?.buyerName
      }else{
        selectBuyerName.current = ""
      }
      if (assetGridFilters?.orderDate) {
        orderDate.current = new Date(assetGridFilters?.orderDate)
      } else {
        orderDate.current = null
      }
      if (assetGridFilters?.updatedDate) {
        updateDate.current = new Date(assetGridFilters?.updatedDate)
      } else {
        updateDate.current = null
      }
    } else {
      setQuantityFilter(requestGridFilters?.quantity);
      setOrderPriceFilter(requestGridFilters?.orderPrice)
      setFrsOrderNumberFilter(requestGridFilters?.frsOrderNumber)
      setCommentFilter(requestGridFilters?.comment)
      if (requestGridFilters.status) {
        selectStatus.current = requestGridFilters?.status
      }else{
        selectStatus.current = ""
      }
      if (requestGridFilters.regionName) {
        selectRegion.current = requestGridFilters?.regionName
      }else{
        selectRegion.current = ''
      }
      if (requestGridFilters.costCenter) {
        selectCostCenter.current = requestGridFilters?.costCenter
      }else{
        selectCostCenter.current = ""
      }
      if (requestGridFilters.requestedBy) {
        selectRequestedBy.current = requestGridFilters?.requestedBy
      }else{
        selectRequestedBy.current = ""
      }
      if (requestGridFilters.assignedTo) {
        selectAssignedTo.current = requestGridFilters?.assignedTo
      }else{
        selectAssignedTo.current = ""
      }
      if (requestGridFilters.updatedBy) {
        selectUpdatedBy.current = requestGridFilters?.updatedBy
      }else{
        selectUpdatedBy.current = ""
      }
      if(requestGridFilters?.fleetItemStatus){
        selectItemStatus.current = requestGridFilters?.fleetItemStatus
      }else{
        selectItemStatus.current = ""
      }
      if (requestGridFilters?.orderRequestType) {
        selectRequsetType.current = requestGridFilters?.orderRequestType
      }else{
        selectRequsetType.current = ""
      }
      if (requestGridFilters?.orderDate) {
        orderDate.current = new Date(requestGridFilters?.orderDate)
      } else {
        orderDate.current = null
      }
      if (requestGridFilters?.updatedDate) {
        updateDate.current = new Date(requestGridFilters?.updatedDate)
      } else {
        updateDate.current = null
      }
      if(requestGridFilters?.orderPrice){
        orderPriceFilterRef.current = requestGridFilters?.orderPrice
      }else{
        orderPriceFilterRef.current = ""
      }
    }
 }

  useEffect(() => {
    setValues()
  }, [])

  useEffect (() => {
    setValues()
  },[requestGridFilters, assetGridFilters])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setQuantityFilter(assetGridFilters?.quantity);
    } else {
      setQuantityFilter(requestGridFilters?.quantity);
    }
  }, [assetGridFilters?.quantity, requestGridFilters?.quantity])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setOrderIdFilter(assetGridFilters?.orderId);
    } else {
      setOrderIdFilter(requestGridFilters?.orderId);
    }
  }, [assetGridFilters?.orderId, requestGridFilters?.orderId])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      if(activeMenu == CONSTANTS.GRID_ACTIVE_MENU.SAVED){
        setAssetNumberFilter(assetGridFilters?.assetNumbers);
      }
    }else{
      if(activeMenu == CONSTANTS.GRID_ACTIVE_MENU.SAVED){
        setAssetNumberFilter(requestGridFilters?.assetNumbers);
      }
    }
  }, [assetGridFilters?.assetNumbers, requestGridFilters?.assetNumbers])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setOrderPriceFilter(assetGridFilters?.orderPrice)
    } else {
      setOrderPriceFilter(requestGridFilters?.orderPrice);
    }
  }, [assetGridFilters?.orderPrice, requestGridFilters?.orderPrice])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setFrsOrderNumberFilter(assetGridFilters?.frsOrderNumber)
    } else {
      setFrsOrderNumberFilter(requestGridFilters?.frsOrderNumber)
    }
  }, [assetGridFilters?.frsOrderNumber, requestGridFilters?.frsOrderNumber])

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      setCommentFilter(assetGridFilters?.comment)
    } else {
      setCommentFilter(requestGridFilters?.comment);
    }
  }, [assetGridFilters?.comment, requestGridFilters?.comment])

  useEffect(() => {
    if (data?.length) {
      const updatedOrderList = data?.map((item: any) => ({
        ...item,
        orderDate: Moment(item.orderDate).format("MM/DD/YYYY"),
        updatedDate: Moment(item.updatedDate).format("MM/DD/YYYY"),
        fleetItemStatus: item.fleetItemDetail?.map((i: any) => i.itemStatus),
      }));
      setOrderList(updatedOrderList);
    } else {
      setOrderList([]);
    }
    if (data?.length <= 10) {
      document.querySelector(".step-next")?.classList.add("disabled");
      document.querySelector(".step-last")?.classList.add("disabled");
    }
    if (data?.length > 10) {
      document.querySelector(".step-next")?.classList.remove("disabled");
      document.querySelector(".step-last")?.classList.remove("disabled");
    }
  }, [data]);

  useEffect(() => {
    if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
      orderRequestList.current = assetTypeDropdownList?.map((item?: any) => {
        return { label: item.orderRequestType, value: item?.orderRequestType, ...item }
      })
    } else {
      const list = requisitionTypeDropdownList?.filter((i: any) => {
        return i.orderRequestType !== "Select Requisition Type";
      })
      orderRequestList.current = list?.map((item?: any) => {
        return { label: item.orderRequestType, value: item?.orderRequestType, ...item }
      })
    }
  }, [requisitionTypeDropdownList, assetTypeDropdownList, activeNavigation])

  useEffect(() => {
    orderStatusList.current = statusDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [statusDropdownList])

  useEffect(() => {
    regionList.current = regionDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [regionDropdownList])

  useEffect(() => {
    costCenterList.current = costCenterDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [costCenterDropdownList])

  useEffect(() => {
    requestedByList.current = requestedByDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [requestedByDropdownList])

  useEffect(() => {
    assignedToList.current = assignedToDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [assignedToDropdownList])

  useEffect(() => {
    updatedByList.current = updatedByDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [updatedByDropdownList])

  useEffect(() => {
    fleetItemStatusList.current = itemStatusDropdownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [itemStatusDropdownList])

  useEffect(() => {
    buyerNameList.current = buyerNameDropDownList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
  }, [buyerNameDropDownList])

  const iconReturn = (status: any) => {
    const icon = GetStatusIcon(status)?.icon;
    let classNameTemp = "";
    if (status === CONSTANTS.ORDER_STATUS.FLEET_PROCESSING || status === CONSTANTS.ORDER_STATUS.PROCESSING) {
      classNameTemp = 'fleetprocessingicon statusIcon';
    } else {
      classNameTemp = 'statusIcon'
    }
    return <img src={icon} alt="statusIcon" className={classNameTemp} />;
  };

  const handleOrderClearSelectFilter = (search: any, value: any, column: any) => {
    if (column.key === 'costCenter') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ costCenter: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ costCenter: '' }))
      }
    }

    if (column.key === 'regionName') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ regionName: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ regionName: '' }))
      }
    }

    if (column.key === 'status') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ status: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ status: '' }))
      }
    }
    if (column.key === 'orderRequestType') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ orderRequestType: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ orderRequestType: '' }))
      }
    }
    if (column.key === 'requestedBy') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ requestedBy: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ requestedBy: '' }))
      }
    }
    if (column.key === 'updatedBy') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ updatedBy: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ updatedBy: '' }))
      }
    }
    if (column.key === 'buyerName') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ buyerName: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ buyerName: '' }))
      }
    }
    if (column.key === 'assignedTo') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ assignedTo: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ assignedTo: '' }))
      }
    }
    search(undefined);
    value.current = "";
  };


  const setFilters = (value: any) => {
    if (JSON.stringify(value) !== '{}') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ ...assetGridFilters, ...value }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ ...requestGridFilters, ...value }))
      }
    }
  }

  const CustomFilterCell = (props: any) => {
    const { column, search, options } = props;
    const myOrderHandleChange = (event: any, columnName?: any) => {
      if (event?.label !== CONSTANTS.SELECT) {
        if (columnName === "costCenter") {
          selectCostCenter.current = event?.label;
          search(event?.label);
        } else if (columnName === "status") {
          selectStatus.current = event?.label;
          search(event?.label);
        } else if (columnName === 'regionName') {
          selectRegion.current = event?.label
          search(event?.label);
        } else if (columnName === "requestedBy") {
          selectRequestedBy.current = event?.label
          search(event?.label)
        } else if (columnName === "assignedTo") {
          selectAssignedTo.current = event?.label;
          search(event?.label)
        } else if (columnName === "updatedBy") {
          selectUpdatedBy.current = event?.label
          search(event?.label)
        } else if (columnName === "fleetItemStatus") {
          selectItemStatus.current = event?.label
          search(event?.label)
        } else if (columnName === "buyerName") {
          selectBuyerName.current = event?.label
          search(event?.label)
        } else {
          selectRequsetType.current = event?.label;
          search(event?.label);
        }
      } else {
        if (columnName === "regionName") {
          selectRegion.current = event?.label
        } else if (columnName === "costCenter") {
          selectCostCenter.current = event?.label;
        } else if (columnName === "requestedBy") {
          selectRequestedBy.current = event?.label;
        } else if (columnName === "assignedTo") {
          selectAssignedTo.current = event?.label
        } else if (columnName === "updatedBy") {
          selectUpdatedBy.current = event?.label
        } else if (columnName === "fleetItemStatus") {
          selectItemStatus.current = event?.label
        } else if (columnName === "buyerName") {
          selectBuyerName.current = event?.label
        } else if (columnName === "status") {
          selectStatus.current = event?.label;
        } else {
          selectRequsetType.current = event?.label;
        }
        search();
      }
    };

    const getValue = () => {
      if (column.key === "costCenter") {
        return selectCostCenter
      } else if (column.key === "status") {
        return selectStatus
      } else if (column.key === "regionName") {
        return selectRegion
      } else if (column?.key === "requestedBy") {
        return selectRequestedBy
      } else if (column?.key === "assignedTo") {
        return selectAssignedTo
      } else if (column?.key === "updatedBy") {
        return selectUpdatedBy
      } else if (column?.key === "fleetItemStatus") {
        return selectItemStatus
      } else if (column?.key === "buyerName") {
        return selectBuyerName
      } else {
        return selectRequsetType;
      }
    }

    let filterDropDown = commonFilterDropDown(props?.onClickValue, getValue, column, myOrderHandleChange, options, handleOrderClearSelectFilter, search)
    return filterDropDown
  }

  const handleOrderDateFilter = (date: any, search: any, setDate: any) => {
    search(Moment(date).format("MM/DD/YYYY"));
    setDate.current = date;
  };

  const handleOrderClearDateFilter = (search: any, setDate: any, column: any) => {
    if (column.key === 'orderDate') {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ orderDate: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ orderDate: '' }))
      }
    } else {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ updatedDate: '' }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ updatedDate: '' }))
      }
    }
    search(undefined);
    setDate.current = undefined;
  };

  const OrderGridDateFilterCell = (orderDateData: any) => {
    const { search, column } = orderDateData;
    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder="select"
          onChangeDate={(date: any) =>
            handleOrderDateFilter(date, search, orderDate)
          }
          value={orderDate.current}
          allowTextInput={false}
         data-attribute="MyOrderGrid_container_Default_Datepicker" />
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => handleOrderClearDateFilter(search, orderDate, column)}
        ></i>
      </div>
    );
  };

  const UpdateGridDateFilterCell = (updateDateData: any) => {
    const { search, column } = updateDateData;
    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder="select"
          onChangeDate={(date: any) =>
            handleOrderDateFilter(date, search, updateDate)
          }
          value={updateDate.current}
         data-attribute="MyOrderGrid_container_Default_Datepicker_2" />
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => handleOrderClearDateFilter(search, updateDate, column)}
        ></i>
      </div>
    );
  };
  const dispatchSetIsOrderApprovalComplete =
    pendingApprovalOperations.dispatchSetIsOrderApprovalComplete(dispatch);

  const onOrderIdClicked = (e: any, row: any) => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    e.preventDefault();
    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    dispatch(RequisitionAction.setOrderEditNavigateChange("Customer My Orders"));
    const requestType = row?.rowData?.orderType
    let orderId = row?.rowData?.orderId;
    const orderStatus = row?.rowData?.status
    const isBulkOrder = row?.rowData?.isBulkOrder

    let navigationUrl = "";
    if (activeNavigation == 'Customer My Orders') {
      navigationUrl = GetOnOrderIdClickedUrl(orderStatus, requestType, orderId, isBulkOrder,'requisition', activeMenu)
    } else if (activeNavigation == 'Asset') {
      navigationUrl = GetOnOrderIdClickedUrl(orderStatus, requestType, orderId, isBulkOrder,'asset', activeMenu)
    }
    navigate(navigationUrl);
    dispatchSetIsOrderApprovalComplete(false);
  };

  const activeRow = customerMyOrderDetails.dispatchRowData(dispatch);

  const activeRowData = (item: any) => {
    return activeRow(item);
  };

  const orderIdCell = (row?: any) => {
    return(
    <>
            <a
              href="/"
              onClick={(e: any) => {
                onOrderIdClicked(e, row);
                activeRowData(row);
              }}
              className="order-link-id"
            >
              {row.rowData.status == "Unsubmitted"
                ? "Draft"
                : row.rowData.orderId}
            </a>
            {row.rowData.status == "Unsubmitted" ? (
              <img
                src={Edit}
                title="Edit"
                alt="Edit"
                className="edit-icon-grid"
              />
            ) : ""}
          </>
    )
  }

  const orderStatusCell = (row?: any) => {
    return (
      <a
        href="/"
        onClick={(e: any) => {
          onOrderIdClicked(e, row);
          activeRowData(row);
        }}
        className="status"
      >
        {iconReturn(row.rowData.status)}<span className={`${row.rowData.status == 'Fleet Processing' ? 'status-text fleetprocessing' : 'status-text'}`}>{row.rowData.status}</span>
      </a>
    );
  }

  const orderCommentCell = (row?: any) => {
    const temp_comment = row.rowData.comments.map((cmt: any) => { return cmt.comment }).join(" ");
    row.rowData['comment'] = temp_comment;
    const content = row.rowData.approverComments;
    const tooltipProps: any = {
      onRenderContent: () => {
        if (typeof content === "string") {
          return <div>{content}</div>;
        } else if (Array.isArray(content)) {
          return (
            <div className="tooltipConversation">
              {content.map((item: any, index: number) => {
                return (
                  <>
                    <div
                      className={`chat ${item.type === "reply" ? "reply" : "message"
                        }`}
                      key={index}
                    >
                      <p className="author">{item.author}</p>
                      <div className="comment">
                        <p>
                          <span className="blueText">OrderId &nbsp;</span>
                          {row.rowData.orderId}
                        </p>
                        <p className="comment_area">{item.comment}</p>
                      </div>
                    </div>
                    <br />
                  </>
                );
              })}
            </div>
          );
        }
      },
    };
    return row.rowData.approverComments?.length > 0 ? (
      <Tooltip tooltipProps={tooltipProps} data-attribute="MyOrderGrid_container_Default_Tooltip">
        <div className="commentBlock">
          <img src={comment} alt="comment" className="comments" />
        </div>
      </Tooltip>
    ) : null;
  }

 const onTextFieldChange = (e: any) => {
  e.preventDefault();
  setOrderPriceFilter(e.target.value)
  orderPriceFilterRef.current = e.target.value
  if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
    dispatch(GridFiltersAction.setAssetGridFilters({ orderPrice: e.target.value }))
  } else {
    dispatch(GridFiltersAction.setRequestGridFilters({ orderPrice: e.target.value }))
  }
 }

  const orderColumns = [
    {
      key: "orderId",
      title: activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED ? "Draft" : "Order #",
      Cell: (row: any) => {
        let  rowIdVal=orderIdCell(row)
        return rowIdVal},
      width: 80,
      filterRowValue: requestGridFilters?.orderId ?? '',
    },
    {
      key: "status",
      title: "Status",
      Cell: (row: any) => {
        let rowStatusVal = orderStatusCell(row)
        return rowStatusVal
      },
      width: 140,
      filterRowValue: requestGridFilters?.status ?? '',
      FilterCell: (props: any) => {
        return <CustomFilterCell {...props} dataItem={orderList} options={orderStatusList?.current} />;
      },
    },
    {
      key: "orderDate",
      title: activeNavigation == "Asset" ? "Requested Date" : "Order Date",
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.orderDate
              ? Moment(row.rowData.orderDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => {
        return <OrderGridDateFilterCell {...props} dataItem={orderList} />;
      },
      width: 130,
      filterRowValue: requestGridFilters?.orderDate ?? '',
    },
    {
      key: "regionName",
      title: "Region",
      width: 160,
      filterRowValue: requestGridFilters?.region ?? '',
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={regionList.current}
        />
      ),
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 160,
      filterRowValue: requestGridFilters?.costCenter ?? '',
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={costCenterList.current}
        />
      ),
    },
    {
      key: "quantity",
      title: "Qty",
      width: 60,
      filterRowValue: requestGridFilters?.quantity ?? '',
    },
    {
      key: "orderRequestType",
      title: "Request Type",
      width: 120,
      Cell: (typeRow: any) => {
        const requesttype = typeRow.rowData.orderRequestType?.toString();
        return (
          <p>{requesttype?.replaceAll(",", " | ")}</p>
        )
      },
      filterRowValue: requestGridFilters?.orderRequestType ?? '',
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={orderRequestList?.current}
        />
      ),
    },
    {
      key: "requestedBy",
      title: "Created By",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={requestedByList.current}
        />
      ),
      filterRowValue: requestGridFilters?.requestedBy ?? '',
    },
    {
      key: "updatedDate",
      title: "Updated Date",
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.updatedDate
              ? Moment(row.rowData.updatedDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => {
        return <UpdateGridDateFilterCell {...props} dataItem={orderList} />;
      },
      width: 120,
      filterRowValue: requestGridFilters?.updatedDate ?? '',
    },
    {
      key: "updatedBy",
      title: "Updated By",
      width: 100,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={updatedByList.current}
        />
      ),
      filterRowValue: requestGridFilters?.updatedBy ?? '',
    },
    {
      key: "assignedTo",
      title: "Assigned To",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={assignedToList.current}
        />
      ),
      filterRowValue: requestGridFilters?.assignedTo ?? '',
    },

    {
      key: "orderPrice",
      title: "Order Price ($)",
      Cell: (row: any) => {
        return (
          <span>
            {" "}
            {row.rowData.orderPrice != null ? (
              <p>{'$ ' + formatPrice(row.rowData.orderPrice || 0, 2) || '-'}</p>
            ) : (
              ""
            )}
          </span>
        );
      },
      FilterCell: () => {
        return <CustomTextFilterDiv orderPriceFilter = {orderPriceFilterRef.current} onChange = {(e: any) => {onTextFieldChange(e)}} />;
      },
      width: 90
    },
    {
      key: "comment",
      title: "Comments",
      width: 80,
      Cell: (row: any) => {
        let rowCommentval = orderCommentCell(row)
        return rowCommentval;
      }
    },
  ];
  const assetsColumns = [
    {
      key: "orderId",
      title: activeMenu === CONSTANTS.GRID_ACTIVE_MENU.SAVED ? "Draft" : "Order #",
      Cell: (row: any) => {
        let  rowIdVal=orderIdCell(row)
        return rowIdVal
      },
      width: 80,
      filterRowValue: assetGridFilters?.orderId ?? '',
    },
    {
      key: "status",
      title: "Status",
      Cell: (row: any) => {
        let rowStatusVal = orderStatusCell(row)
        return rowStatusVal
      },
      width: 160,
      FilterCell: (props: any) => {
        return <CustomFilterCell {...props} dataItem={orderList} options={orderStatusList?.current} />;
      },
      filterRowValue: assetGridFilters?.status ?? '',
    },
    {
      key: "orderDate",
      title: activeNavigation == "Asset" ? "Requested Date" : "Order Date",
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.orderDate
              ? Moment(row.rowData.orderDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => {
        return <OrderGridDateFilterCell {...props} dataItem={orderList} />;
      },
      width: 120,
      filterRowValue: assetGridFilters?.orderDate ?? '',
    },
    {
      key: "regionName",
      title: "Region",
      width: 160,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={regionList.current}
        />
      ),
      filterRowValue: assetGridFilters?.regionName ?? '',
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 160,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={costCenterList.current}
        />
      ),
      filterRowValue: assetGridFilters?.costCenter ?? '',
    },
    {
      key: "quantity",
      title: "Qty",
      width: 60,
      filterRowValue: assetGridFilters?.quantity ?? '',
    },
    {
      key: "orderRequestType",
      title: "Request Type",
      width: 120,
      Cell: (typeRow: any) => {
        const requesttype = typeRow.rowData.orderRequestType?.toString();
        return (
          <p>{requesttype?.replaceAll(",", " | ")}</p>);
      },
      FilterCell: (props: any) => {
        return <CustomFilterCell {...props} dataItem={orderList} options={orderRequestList?.current} />;
      },
      filterRowValue: assetGridFilters?.orderRequestType ?? '',
    },
    {
      key: "requestedBy",
      title: "Created By",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={requestedByList.current}
        />
      ),
      filterRowValue: assetGridFilters?.requestedBy ?? '',
    },
    {
      key: "updatedDate",
      title: "Updated Date",
      Cell: (row: any) => {
        return (
          <p className="dateSubmitted">
            {row.rowData.updatedDate
              ? Moment(row.rowData.updatedDate).format("MM/DD/YYYY")
              : ""}
          </p>
        );
      },
      FilterCell: (props: any) => {
        return <UpdateGridDateFilterCell {...props} dataItem={orderList} />;
      },
      width: 120,
      filterRowValue: assetGridFilters?.updatedDate ?? '',
    },
    {
      key: "updatedBy",
      title: "Updated By",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={updatedByList.current}
        />
      ),
      filterRowValue: assetGridFilters?.updatedBy ?? '',
    },
    {
      key: "assignedTo",
      title: "Assigned To",
      width: 120,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={orderList}
          options={assignedToList.current}
        />
      ),
      filterRowValue: assetGridFilters?.assignedTo ?? '',
    },
    {
      key: "comment",
      title: "Comments",
      width: 80,
      Cell: (row: any) => {
        let rowCommentval = orderCommentCell(row)
        return rowCommentval;
      },
    },
  ];
  const [columnState, setColumnState] = useState(activeNavigation == "Asset" ? assetsColumns : orderColumns);

  const itemStatusColumn = {
    key: "fleetItemStatus",
    title: "Item Status",
    Cell: (row: any) => {
      return row?.rowData?.fleetItemDetail?.map((item: any) => {
        return <Fragment key={item?.itemNumber || item?.itemStatus}>
          <p>{item?.itemNumber ? `${item?.itemNumber} - ${item?.itemStatus}` : item?.itemStatus}</p>
        </Fragment>
      })
    },
    width: 140,
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={fleetItemStatusList.current}
        />
      )
    },
    filterRowValue: activeNavigation == "Asset" ? assetGridFilters?.fleetItemStatus : requestGridFilters?.fleetItemStatus
  }

  const assetNumberColumn = {
    key: "assetNumbers",
    title: "Asset #",
    width: 80,
    Cell: (typeRow: any) => {
      const requesttype = typeRow.rowData.assetNumbers?.toString();
      return (
        <p>{requesttype?.replaceAll(",", " | ")}</p>);
    },
    filterRowValue: activeNavigation == "Asset" ? assetGridFilters?.assetNumbers : requestGridFilters?.assetNumbers,
  }

  const buyerNameColumn = {
    key: "buyerName",
    title: "Buyer Name",
    width: 140,
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={buyerNameList.current}
        />
      )
    },
    filterRowValue: activeNavigation == "Asset" ? assetGridFilters?.buyerName :  ''
  }

  useEffect(() => {
    if (activeMenu === CONSTANTS.GRID_ACTIVE_MENU.FLEET_PROCESSING || activeMenu === CONSTANTS.GRID_ACTIVE_MENU.PENDING_FLEET_PROCESSING){
      if(activeNavigation == "Asset" ){
        assetsColumns.splice(2, 0, itemStatusColumn);
        assetsColumns.splice(7,0, buyerNameColumn)
        setColumnState(assetsColumns)
      }else{
        orderColumns.splice(2, 0, itemStatusColumn)
        setColumnState(orderColumns)
      } 
    }else if(activeMenu == CONSTANTS.GRID_ACTIVE_MENU.SAVED){
      if(activeNavigation == "Asset" ){
        assetsColumns.splice(1, 0, assetNumberColumn);
        setColumnState(assetsColumns)
      } else{
        orderColumns.splice(1, 0, assetNumberColumn);
        setColumnState(orderColumns)
      }
    }else{
      setColumnState(activeNavigation == "Asset" ? assetsColumns : orderColumns)
    }
  }, [activeMenu, activeNavigation]);

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.pageSize])

  const getFilteredValues = () => {
    let filteredValues: any = [];
    if (orderDate.current != null) {
      filteredValues.push({ 'field': 'orderDate', 'value': Moment(new Date(orderDate.current)).format('YYYY-MM-DD') })
    }
    if (updateDate.current != null) {
      filteredValues.push({ 'field': 'updatedDate', 'value': Moment(new Date(updateDate.current)).format('YYYY-MM-DD') })
    }
    if (selectStatus.current != "") {
      filteredValues.push({ 'field': 'status', 'value': selectStatus.current })
    }
    if (selectRegion.current != "") {
      const findValue = regionList?.current?.find((item: any) => item.label === selectRegion.current)
      filteredValues.push({ 'field': 'regionName', 'value': findValue.value })
    }
    if (selectUpdatedBy.current != "") {
      const findValue = updatedByList?.current?.find((item: any) => item.label === selectUpdatedBy.current)
      filteredValues.push({ 'field': 'updatedBy', 'value': findValue?.value })
    }
    if (selectAssignedTo.current != "") {
      const findValue = assignedToList?.current?.find((item: any) => item.label === selectAssignedTo.current)
      filteredValues.push({ 'field': 'assignedTo', 'value': findValue?.value })
    }
    if (selectRequestedBy.current != "") {
      const findValue = requestedByList?.current?.find((item: any) => item.label === selectRequestedBy.current)
      filteredValues.push({ 'field': 'requestedBy', 'value': findValue?.value })
    }
    if (selectRequsetType.current != "") {
      filteredValues.push({ 'field': 'orderRequestType', 'value': selectRequsetType.current })
    }
    if (selectCostCenter.current != "") {
      const findValue = costCenterList?.current?.find((item: any) => item.label === selectCostCenter.current)
      filteredValues.push({ 'field': 'costCenter', 'value': findValue?.value })
    }
    if (quantityFilter != "" && quantityFilter) {
      filteredValues.push({ 'field': 'quantity', 'value': quantityFilter })
    }
    if (orderIdFilter != "" && orderIdFilter) {
      filteredValues.push({ 'field': 'orderId', 'value': orderIdFilter })
    }
    if (assetNumberfilter != "" && assetNumberfilter) {
      filteredValues.push({ 'field': 'assetNumbers', 'value': assetNumberfilter })
    }
    if (orderPriceFilter != "" && orderPriceFilter) {
      filteredValues.push({ 'field': 'orderPrice', 'value': orderPriceFilter })
    }
    if (frsOrderNumberFilter != "" && frsOrderNumberFilter) {
      filteredValues.push({ 'field': 'frsOrderNumber', 'value': frsOrderNumberFilter })
    }
    if (commentFilter != "" && commentFilter) {
      filteredValues.push({ 'field': 'comment', 'value': commentFilter })
    }
    if (selectItemStatus.current != "") {
      filteredValues.push({ 'field': 'fleetItemStatus', 'value': selectItemStatus.current })
    }
    if (selectBuyerName.current != "") {
      filteredValues.push({ 'field': 'buyerName', 'value': selectBuyerName.current })
    }
    return filteredValues;
  }

  const debounceObject = [
    paginationData, activeMenu, myOrdersearchBoxValue, dateRange, orderDate, updateDate, selectStatus, selectRegion,
    selectUpdatedBy, selectAssignedTo, selectRequestedBy, selectRequsetType, selectCostCenter, selectItemStatus,
    quantityFilter, orderIdFilter, assetNumberfilter, orderPriceFilter, frsOrderNumberFilter, commentFilter, sortData, selectBuyerName
  ]
  const globalDebounce = useDebounce(debounceObject, 500)

  const syncPaginationToFirstPage = useCallback(() => {
    setPaginationData((prev: any) => {
      const nextPaginationData = { ...prev, pageIndex: 0 }
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ paginationData: nextPaginationData }))
      } else {
        dispatch(GridFiltersAction.setRequestGridFilters({ paginationData: nextPaginationData }))
      }
      return nextPaginationData
    })
  }, [activeNavigation, dispatch])

  const fetchGridData = (pageOverride?: number) => {
    const normalizedSearchText = `${myOrdersearchBoxValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy?.value ?? globalSearchBy ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = JSON.stringify(currentColumnFilters)
    const shouldForceFirstPageForCommonSearch = pageOverride === undefined && forceFirstPageForCommonSearchRef.current
    const resolvedPageNumber = pageOverride !== undefined
      ? pageOverride
      : shouldForceFirstPageForCommonSearch
        ? 1
        : (paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined)
    let payload: any = {
      "pageNumber": resolvedPageNumber,
      "pageSize": paginationData?.pageSize,
      "columnFilters": currentColumnFilters,
      "gridFilterName": activeMenu,
      "loggedInMail" : userDetails?.emailId
    }

    payload = fetchGridPayload(payload, dateRange, myOrdersearchBoxValue, sortData, true, globalSearchBy)

    lastCommonSearchSignatureRef.current = currentCommonSearchSignature
  lastColumnFilterSignatureRef.current = currentColumnFilterSignature
    forceFirstPageForCommonSearchRef.current = false

    if (payload.pageNumber && payload.pageSize) {
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(getTransferGridData(payload))
      } else {
        dispatch(getMyOrder(payload))
      }
    }
  }

  useEffect(() => {
    const normalizedSearchText = `${myOrdersearchBoxValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy?.value ?? globalSearchBy ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = JSON.stringify(currentColumnFilters)
    const currentPageIndex = paginationData?.pageIndex ?? 0
    if (lastCommonSearchSignatureRef.current === null || lastColumnFilterSignatureRef.current === null) {
      lastCommonSearchSignatureRef.current = currentCommonSearchSignature
      lastColumnFilterSignatureRef.current = currentColumnFilterSignature
      return
    }
    const hasCommonSearchChanged = currentCommonSearchSignature !== lastCommonSearchSignatureRef.current
    const hasColumnFilterChanged = currentColumnFilterSignature !== lastColumnFilterSignatureRef.current

    if (hasCommonSearchChanged || hasColumnFilterChanged) {
      forceFirstPageForCommonSearchRef.current = true
    }

    if ((hasCommonSearchChanged || hasColumnFilterChanged) && currentPageIndex !== 0) {
      syncPaginationToFirstPage()
      setGridKey((k: number) => k + 1)
    }
  }, [globalDebounce, paginationData?.pageIndex, syncPaginationToFirstPage])

  useEffect(() => {
    fetchGridData()
  }, [globalDebounce])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPaginationData(paginationData)
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ paginationData }))
      } else {
        dispatch(GridFiltersAction?.setRequestGridFilters({ paginationData }))
      }
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortData(data);
      if (activeNavigation === ACTIVE_NAVIGATION.ASSET) {
        dispatch(GridFiltersAction.setAssetGridFilters({ sortData: data }))
      } else {
        dispatch(GridFiltersAction?.setRequestGridFilters({ sortData: data }))
      }
    }
  }, [activeNavigation, dispatch])

  return (
    <MyOrderGrid
      data={orderList}
      columns={columnState}
      setFilters={setFilters}
      fetchAction={fetchAction}
      gridKey={gridKey}
      serverTotal={serverTotal}
      pagesCount={pagesCount}
      activeMenu={activeMenu}
      isMyOrdersGridLoading={isMyOrdersGridLoading}
      isDropDownsLoading={isDropDownsLoading}
    />
  );
};

export default MyOrderGridContainer;